import React from 'react'; 
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { browserHistory } from 'react-router';


class ConfirmEmail extends React.Component {
  constructor(props) {
    super(props);
    props.initAPI();
    props.resetUpdateEmailSuccess();
    this.state = { isConfirmEmailCalled: false };
  }


  componentWillReceiveProps(p) {
    if (p.userId && p.email && p.code && !this.state.isConfirmEmailCalled) {
      this.setState({ isConfirmEmailCalled: true });
      let model = {
        UserId: p.userId,
        email: p.email,
        Code: p.code
      };
      p.confirmEmail(model);
    }
  }

  render() {
    const p = this.props;
    const technicalError = window.osa && window.osa.commonLookup && window.osa.commonLookup.technicalError;
    return (
      <div className="row">
        <div className="col-md-12">
          <h3 className="panel-title text-primary" style={{ "font-size": "24px" }}>Service request profile</h3> <br />
          <br />
          {
            this.state.isConfirmEmailCalled ?
              <div>
                {
                  p.updateEmailSuccess ?
                    <p>
                      Your email is now confirmed. You may now <a onClick={() => browserHistory.push('/login')}>log in.</a>
                    </p>
                    :
                    <div className="row animated-element animate-show" >
                      <span dangerouslySetInnerHTML={{ __html: technicalError }} />
                    </div>
                }
              </div>
              : null
          }
        </div>
      </div>
    );
  }
}

ConfirmEmail.propTypes = {
  form: PropTypes.object,
  password: PropTypes.string,
  userId: PropTypes.string,
  code: PropTypes.string,
  email: PropTypes.string,
  updateEmailSuccess: PropTypes.bool,
  initAPI: PropTypes.func
};

function mapStateToProps(state) {
  return {
    form: state.form,
    userId: state.routing.locationBeforeTransitions && state.routing.locationBeforeTransitions.query["userId"],
    code: state.routing.locationBeforeTransitions && state.routing.locationBeforeTransitions.query["code"],
    email: state.routing.locationBeforeTransitions && state.routing.locationBeforeTransitions.query["email"],
    updateEmailSuccess: state.gas.updateEmailSuccess
  };
}
function mapDispatchToProps(dispatch) {
  return {
    initAPI: () => {
      dispatch({ type: 'INITIALIZE_API' });
    },
    formError: (name, error) => dispatch({ type: 'FORM_ERROR', name, error }),
    confirmEmail: (model) => dispatch({ type: 'UPDATE_EMAIL', model }),
    resetUpdateEmailSuccess: () => dispatch({ type: 'UPDATE_EMAIL_SUCCESS', updateEmailSuccess: false }),

  };
}
export default connect(mapStateToProps, mapDispatchToProps)(ConfirmEmail);

